
export default {
  name: 'FatcaCrsInfo',
}
